import { useMemo } from 'react'
import { toast } from 'sonner'
import { apiErrorMessage } from '@/i18n'
import { useCrmLookups, useCustomers } from './api'

export function toastError(e: unknown) {
  toast.error(apiErrorMessage(e))
}

/** Personel, proje ve müşteri adları için arama tabloları. */
export function useCrm() {
  const lookups = useCrmLookups()
  const customers = useCustomers()
  return useMemo(() => {
    const staff = lookups.data?.staff ?? []
    const projects = lookups.data?.projects ?? []
    const staffById = new Map(staff.map((s) => [s.id, s]))
    const projectById = new Map(projects.map((p) => [p.id, p]))
    const customerById = new Map((customers.data ?? []).map((c) => [c.id, c]))
    return {
      staff,
      projects,
      moduleCatalog: lookups.data?.moduleCatalog ?? [],
      customers: customers.data ?? [],
      staffName: (id: string | null) => (id ? (staffById.get(id)?.name ?? '—') : '—'),
      staffTitle: (id: string | null) => (id ? (staffById.get(id)?.title ?? '') : ''),
      projectName: (id: string) => projectById.get(id)?.name ?? '—',
      customerName: (id: string) => customerById.get(id)?.name ?? '—',
      customerById,
    }
  }, [lookups.data, customers.data])
}

/** Telefon ve vergi no ekranda maskeli gösterilir (KVKK); tam değer form ve düzenlemede görünür. */
export const maskPhone = (v: string) => (v.length > 8 ? `${v.slice(0, 7)} *** ** ${v.slice(-2)}` : v)
export const maskTaxNo = (v: string) => (v.length > 4 ? `${v.slice(0, 2)}${'*'.repeat(v.length - 4)}${v.slice(-2)}` : v)
